import { authTokenKeyName } from "src/utils/configs/authConfig";
import { Navigate } from "react-router-dom";

const LandingPage = () => {
  const isLogin = localStorage.getItem(authTokenKeyName);

  if (isLogin) {
    return <Navigate to="/welcome" />;
  } else {
    return <Navigate to="/" />;
  }
};

export default LandingPage;
